import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UpsiDetailsService {

  constructor(private httpService: HttpService,private httpClient: HttpClient) { }

  addUPSI(newSharer) {
    var request = {
        URL: "upsidetails/add",
        DATA: newSharer
    }
    return this.httpService.post(request);        
}

uploadFile(id, formData) {
    var request = {
        URL: "upsidetails/fileUpload/"+ id,
        DATA: formData
    }
    return this.httpService.post(request);        
}

updateUPSI(id, object)  {
    var request = {
        URL: "upsidetails/update/"+ id,
        DATA: object
    }
    return this.httpService.post(request);        
}

deleteFile(id)  {
    var request = {
        URL: "upsidetails/deleteFile/"+ id
    }
    return this.httpService.get(request);        
}

addToUPSIDetails(newSharer) {
    var request = {
        URL: "upsi/addToUPSIDetails",
        DATA: newSharer
    }
    return this.httpService.post(request);        
}


getUpsiBulkData() {
    let request = { URL : "upsi/blukdata"}
    return this.httpService.get(request)
}

getUpsiBulkDataById(id){
    let request = { URL : "upsi/getBulkDataById/" + id}
    return this.httpService.get(request)
}

deleteUPSIBulkDataById(id) {
    let request = { URL : "upsi/deleteBlukdataById/" + id}
    return this.httpService.get(request)
}

updateBulkUPSI(id, object)  {
    var request = {
        URL: "upsi/updateBlukdataById/"+ id,
        DATA: object
    }
    return this.httpService.post(request);        
}

downloadSample(companyId){
    let request = { URL : "upsi/downloadSample/" + companyId}
    return this.httpClient.get(environment.pssServerUrl + request.URL, {headers: this.httpService.addHeaders(), responseType: 'json'})
    // return this.httpClient.get(environment.pssServerUrl + request.URL, {headers: this.httpService.addHeaders(), responseType: 3})
}

statusClosed(selectedIds){
    var request = {
        URL: "upsiDetails/updateShowHideStatus",
        DATA: selectedIds
    }
    return this.httpService.post(request); 
}

sendUPSIDetailsEmail(paramData){
    var request = {
        URL: "upsidetails/sendUPSIDetailsEmail",
        DATA:paramData
    }
    return this.httpService.post(request);
}

addSelectedUpsiBulkData(object){
    var request = {
        URL: "upsi/addMultipleUPSIDetails/",
        DATA: object
    }
    return this.httpService.post(request);  
}

deleteSelectedUpsiBulkData(object){
    var request = {
        URL: "upsi/deleteMultipleBulkData/",
        DATA: object
    }
    return this.httpService.post(request);  
}
}
